import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { IPaymentSettings } from 'src/app/store/payment-settings/payment-settings.actions';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CustomBankService {
  constructor(private http: HttpClient) {}

  get(id: any) {
    return this.http.get(
      `${environment.url}/clients/${id}`
    ).pipe(map((res: any) => res['paymentSetting'])) as Observable<IPaymentSettings>;
    // .pipe(map((res: any) => res['hydra:member']))
  }

  getAll() {
    return this.http.get('https://api-fake-r9p5.onrender.com/customBanks') as Observable<
      any[]
    >;
    // .pipe(map((res: any) => res['hydra:member']))
  }

  save(req: any) {
    return this.http.post(
      'https://api-fake-r9p5.onrender.com/customBanks',
      req
    ) as Observable<any>;
  }

  edit(req: any, id: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    });
    return this.http.patch(`${environment.url}/customBanks/${id}`, req, {
      headers: headers,
    }) as Observable<any>;
  }

  delete(id: number) {
    return this.http.delete(
      `https://api-fake-r9p5.onrender.com/customBanks/${id}`
    ) as Observable<any>;
  }
}
